﻿export const AppContainerId = 'veilederNordenHelgrad';
export const BoksA = 'boks-A';
export const BoksB = 'boks-B';
export const BoksC = 'boks-C';
export const BoksD = 'boks-D';